import { PanelRight } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { useWidgetTabs } from "@/hooks/useWidgetTabs"
import { useTranslation } from "react-i18next"

/**
 * The widget panel's show/hide switch. Reads the shared `useWidgetTabs` store,
 * so it can live wherever — currently in the driver chat's top bar, next to
 * the driver-info actions. Adding widgets and splitting windows belongs to the
 * panel itself (per-window "+", tab ×, drag a tab onto an edge).
 */
const WidgetLayoutControls = () => {
  const { t } = useTranslation()
  const { hidden, togglePanel } = useWidgetTabs()

  const layoutLabel = hidden
    ? t("chatHeader.showWidgets")
    : t("chatHeader.hideWidgets")

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn(
        "h-9 w-9 shrink-0",
        !hidden &&
          "bg-base-primary/10 text-base-primary hover:bg-base-primary/15 hover:text-base-primary",
      )}
      aria-label={layoutLabel}
      title={layoutLabel}
      onClick={togglePanel}
    >
      <PanelRight className="h-4 w-4" />
    </Button>
  )
}

export default WidgetLayoutControls
